__turbopack_context__.v({
  "accordionChevron": "styles-module__wYmQXW__accordionChevron",
  "accordionContent": "styles-module__wYmQXW__accordionContent",
  "accordionDesktopHeader": "styles-module__wYmQXW__accordionDesktopHeader",
  "accordionResponsiveContent": "styles-module__wYmQXW__accordionResponsiveContent",
  "accordionResponsiveContent--expanded": "styles-module__wYmQXW__accordionResponsiveContent--expanded",
  "accordionTitle": "styles-module__wYmQXW__accordionTitle",
  "accordionToggleButton": "styles-module__wYmQXW__accordionToggleButton",
  "accordionToggleButton--responsive": "styles-module__wYmQXW__accordionToggleButton--responsive",
  "campaignBanners": "styles-module__wYmQXW__campaignBanners",
  "content": "styles-module__wYmQXW__content",
  "description": "styles-module__wYmQXW__description",
  "discountedPrice": "styles-module__wYmQXW__discountedPrice",
  "errorText": "styles-module__wYmQXW__errorText",
  "feedback": "styles-module__wYmQXW__feedback",
  "imageContainer": "styles-module__wYmQXW__imageContainer",
  "imageLink": "styles-module__wYmQXW__imageLink",
  "orderSummaryContainer": "styles-module__wYmQXW__orderSummaryContainer",
  "price": "styles-module__wYmQXW__price",
  "products": "styles-module__wYmQXW__products",
  "removeButton": "styles-module__wYmQXW__removeButton",
  "sellerContainer": "styles-module__wYmQXW__sellerContainer",
  "sellerInfo": "styles-module__wYmQXW__sellerInfo",
  "sellerUsername": "styles-module__wYmQXW__sellerUsername",
  "size": "styles-module__wYmQXW__size",
  "soldImage": "styles-module__wYmQXW__soldImage",
  "title": "styles-module__wYmQXW__title",
  "totalRow": "styles-module__wYmQXW__totalRow",
  "wrapper": "styles-module__wYmQXW__wrapper",
});
